<div class="container">
  <section class="section">
    <div class="container">
      <div class="row">
        <div class="col-md-12 col-lg-8 d-flex align-items-center mt-4 mt-md-0">
          <div style="text-align: left">
            <h1>Support kontaktieren</h1>
            <p class="margin-top-s">
              Du brauchst Service oder Support?<br />Stell deine Anfrage online und wir finden eine Lösung für dich.
            </p>
            <form (ngSubmit)="sendSupport()" [formGroup]="supportForm" novalidate>
              <div class="card mb-4 box-shadow">
                <div class="card-header">
                  <h4 class="my-0 font-weight-normal">
                    <mat-form-field style="width: 100%" [hideRequiredMarker]="true">
                      <input type="text" matInput formControlName="subject" [placeholder]="'Betreff'" required />
                      <mat-error *ngIf="supportForm.controls['subject'].invalid && supportForm.controls['subject'].touched">
                        <span>Betreff muss angegeben werden</span>
                      </mat-error>
                    </mat-form-field>
                  </h4>
                </div>
                <div class="card-body">
                  <mat-form-field style="width: 100%" [hideRequiredMarker]="true">
                    <textarea
                      matInput
                      cdkTextareaAutosize
                      cdkAutosizeMinRows="5"
                      cdkAutosizeMaxRows="5"
                      formControlName="message"
                      [placeholder]="'Nachricht'"
                      required></textarea>

                    <mat-error *ngIf="supportForm.controls['message'].invalid && supportForm.controls['message'].touched">
                      <span>Nachricht muss angegeben werden</span>
                    </mat-error>
                  </mat-form-field>

                  <!-- DEBUG: Test recipient -->
                  <div *ngIf="showSupportDebug" style="margin-top: 8px; padding: 8px; background: #fff3cd; border: 1px solid #ffc107; border-radius: 4px; font-size: 12px;">
                    <label><strong>DEBUG:</strong> Test-Empfänger (optional, z.B. Gmail):</label>
                    <input type="email" formControlName="test_email" placeholder="your@gmail.com"
                      style="width: 100%; padding: 4px 8px; margin-top: 4px; font-size: 12px; border: 1px solid #ccc; border-radius: 4px;" />
                  </div>

                  <p>&nbsp;</p>

                  <button
                    class="btnLogin"
                    mat-focus-indicator
                    mat-raised-button
                    color="primary"
                    type="submit"
                    [disabled]="supportForm.invalid">
                    <span>Anfrage senden</span>
                  </button>
                </div>
              </div>
            </form>
            <!-- DEBUG: Mail Debug Output -->
            <div *ngIf="sending" style="margin-top: 16px; padding: 12px; background: #fffbe6; border: 1px solid #e6d84c; border-radius: 4px;">
              <strong>Sende E-Mail...</strong> Bitte warten.
            </div>

            <div *ngIf="showSupportDebug && mailDebug && mailDebug.length > 0" style="margin-top: 16px; padding: 12px; background: #f0f0f0; border: 1px solid #ccc; border-radius: 4px; font-size: 11px; font-family: monospace; max-height: 400px; overflow-y: auto;">
              <strong>Mail Debug Log:</strong>
              <div *ngFor="let line of mailDebug" style="padding: 1px 0; white-space: pre-wrap; word-break: break-all;">{{ line }}</div>
            </div>

            <div *ngIf="showSupportDebug && mailSmtpDebug" style="margin-top: 8px; padding: 12px; background: #e8f4e8; border: 1px solid #8bc38b; border-radius: 4px; font-size: 11px; font-family: monospace; max-height: 300px; overflow-y: auto;">
              <strong>SMTP Debug Output:</strong>
              <pre style="margin: 4px 0; white-space: pre-wrap; word-break: break-all;">{{ mailSmtpDebug }}</pre>
            </div>
            <!-- /DEBUG -->

            <p>&nbsp;</p>
            <p>
              Wenn du uns direkt kontaktieren willst: <br />
              <strong>
                <br />
                support@parkraumplus.at <br />
                +44 1 890 39 54 <br />
                <br />
                Pappenheimgasse 33/10<br />
                1200 Wien<br />
                Austria<br />
                <br />
              </strong>
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
